import { render, staticRenderFns } from "./sessionsView.vue?vue&type=template&id=689688be"
import script from "./sessionsView.vue?vue&type=script&lang=js"
export * from "./sessionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports